import React from 'react';
import { InstagramSocialCircle } from 'components/SocialCircle';
import SocialButton, { SocialButtonProps } from './SocialButton';

export interface InstagramButtonProps
  extends Pick<
    SocialButtonProps,
    'disabled' | 'onClick' | 'size' | 'tooltip'
  > {}

const InstagramButton: React.FC<InstagramButtonProps> = ({
  disabled,
  onClick,
  size,
  tooltip,
}) => (
  <SocialButton
    icon={<InstagramSocialCircle />}
    label="Instagram"
    {...{ disabled, onClick, size, tooltip }}
  />
);

export default InstagramButton;
